/*
Config on tailwind.config.js/

extend:{
  keyframes:{
  logo:{
    '0%': {bottom:"-10px"},
    '50%' : {top:"0"}, 
    '100%': {bottom:"-10px", right:"-10px"},
  }
}

}
*/

interface Fetch {
  className?: string
  text?: string
}

const Fetching = ({ className, text }: Fetch) => {
  return (
    <div
      className={
        className
          ? className
          : 'fixed left-0 top-0 z-50 h-full w-full rounded-lg bg-white bg-opacity-80'
      }
    >
      <div className={`flex h-full flex-col items-center justify-center`}>
        <div className="relative grid h-12 w-12 grid-cols-2 grid-rows-2 gap-2 shadow-inner">
          <div className="relative h-6 w-6 bg-black text-white"></div>
          <div className="h-6 w-6 bg-black text-white"></div>
          <div className="h-6 w-6 bg-black text-white"></div>
          <div className="h-6 w-6 rounded-full bg-orange-600"></div>
          <div className="absolute h-7 w-7 animate-[fetch_1s_linear_infinite_normal] bg-white opacity-40"></div>
        </div>
        {text && <p className="pt-3 text-gray-800">{text}</p>}
      </div>
    </div>
  )
}

export default Fetching
